<template>
  <div>
    <!-- 为空拦截弹窗 -->
    <div class="delete">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.batchDelete"
        :close-on-click-modal="false"
      >
        <p v-if="fang === 0">输入名称不能为空</p>
        <p v-else-if="fang === 1">输入的名称已经存在，请重新输入</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.batchDelete = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisibleObj.batchDelete = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 删除 -->
    <div class="delete_view delete">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.deleteStabe"
        :close-on-click-modal="false"
      >
        <p v-if="$parent.deleteState == 0">
          一旦删除"{{
            determineRow.AppClassName
          }}",该类目下的所有信息将不保存,确定要删除"{{
            determineRow.AppClassName
          }}"吗？
        </p>
        <p v-if="$parent.deleteState == 1">
          该操作是批量删除系统目录,是否继续？
        </p>
        <p v-if="$parent.deleteState == 2">请选择要批量删除的系统目录！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.deleteStabe = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="determine"
            v-if="$parent.deleteState == 0"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="determineArr"
            v-if="$parent.deleteState == 1"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisibleObj.deleteStabe = false"
            v-if="$parent.deleteState == 2"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 修改题库 -->
    <div class="everywhere">
      <el-dialog
        title="修改系统目录名称"
        :visible.sync="dialogVisibleObj.ModifyThe"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="add_bank">
          <el-form
            :model="ModifyForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="系列目录名称：" prop="ModifyName">
              <el-input
                v-model.trim="ModifyForm.ModifyName"
                placeholder="请输入系列目录名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.ModifyThe = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="ModifyTheBtn()"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 试题保护弹窗 -->
    <div class="protect_the">
      <el-dialog
        title="试题保护加密"
        :visible.sync="dialogVisibleObj.everywhere"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>
            试题保护已关闭，请输入超级管理员“{{
              $parent.userName.realName
            }}”的独立密码进行验证。
          </p>
          <el-form
            :model="passwordForm"
            :rules="isrules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item prop="userPaw">
              <el-input
                v-model.trim="passwordForm.userPaw"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <p>
            如果您忘记了独立密码，请联系我们的业务经理协助处理，或致电0772-3998898
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.everywhere = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="encryPwa">验 证</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import {
  Delete,
  Update,
  CryptoCustomApp,
  DeleteBatch,
} from "@/api/quebankmana.js";
import { protectPass } from "@/utils/validata";
import md5 from "js-md5";
export default {
  data() {
    return {
      dialogVisibleObj: {
        batchDelete: false, // 为空判断
        deleteStabe: false, // 删除
        ModifyThe: false, // 修改
        everywhere: false, // 试题加密
      },
      fang: 0,
      Status: "", //密码验证是否正确
      textName: "",
      ModifyForm: {
        ModifyName: "",
      },
      passwordForm: {
        userPaw: "",
      },
      rules: {
        ModifyName: [
          { required: true, message: "请输入系列目录名称", trigger: "blur" },
        ],
      },
      isrules: {
        userPaw: [{ validator: protectPass(this), trigger: "blur" }],
      },
    };
  },
  props: ["determineRow"],
  methods: {
    addCurrent() {
      console.log(this.determineRow.AppClassName);
    },
    async determine() {
      this.dialogVisibleObj.deleteStabe = false;
      let res = {
        CptID: this.determineRow.AppClassID,
        Level: 0,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await Delete(res);
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你,删除成功!",
          type: "success",
        });
        this.$parent.getDatalist(); // 重新发起请求
      } else {
        this.$message.error("很抱歉,删除失败!");
      }
      console.log(Data.status);
    },
    // 批量删除
    async determineArr() {
      let res = {
        Level: 0,
        CptIDArr: `[${this.$parent.multipleSelectionIds}]`,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await DeleteBatch(res);
      if (Data.status === 200) {
        this.$message({
          message: "恭喜你,批量删除成功!",
          type: "success",
        });
        this.dialogVisibleObj.deleteStabe = false;
        this.$parent.getDatalist(); // 重新发起请求
      } else {
        this.$message.error("很抱歉,批量删除失败!");
      }
    },
    // 修改题库
    async ModifyTheBtn() {
      let res = {
        CptID: this.determineRow.AppClassID,
        Level: 0,
        ChapterName: this.ModifyForm.ModifyName,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      if (this.ModifyForm.ModifyName == "") {
        this.$message({
          message: "警告,系统目录名称不能为空!",
          type: "warning",
        });
      } else {
        const Data = await Update(res);
        if (Data.status === 200) {
          this.$message({
            message: "恭喜你,修改成功!",
            type: "success",
          });
          this.dialogVisibleObj.ModifyThe = false;
          this.$parent.getDatalist(); // 重新发起请求
        } else {
          this.$message.error("很抱歉,修改失败!");
        }
      }
    },
    // 密码加密
    async encryPwa() {
      let res = {
        cryptoPwd: md5(this.passwordForm.userPaw),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await CryptoCustomApp(res);
      this.Status = Data.data.Status;
      if (Data.data.Status === 200) {
        // 去页面
        this.$parent.protectList();
        //  this.Data.data.Data =
        // this.$parent.cutcoms(3);
        // if( this.$parent.isHavePwd == 1){
        //    this.$parent.isHavePwd = 0
        // }else{
        //    this.$parent.isHavePwd = 1
        // }

        this.dialogVisibleObj.everywhere = false;
      } else {
        this.$message.error(Data.data.Data);
      }
      console.log(Data.data.Status);
    },
  },
};
</script>

<style lang="scss" scoped>
.delete {
  ::v-deep .el-dialog {
    width: 300px;
    height: 200px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
    }
  }
  ::v-deep .el-dialog__header {
    line-height: 0;
  }
  ::v-deep .el-dialog__body {
    p {
      height: 45px;
      margin-top: 20px;
      line-height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 20px !important;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.delete_view {
  ::v-deep .el-dialog {
    width: 400px;
    height: 240px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
    }
  }
  p {
    padding: 0px 24px;
    margin-top: 36px !important;
  }
  .el-dialog__footer span > button {
    margin-top: 51px !important;
  }
}
// 修改题库
.everywhere {
  ::v-deep .el-dialog {
    width: 552px !important;
    height: 240px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__body {
    padding: 24px;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    line-height: 24px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
  ::v-deep.el-form-item__label {
    width: 120px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 120px !important;
  }
  ::v-deep.el-input__inner {
    width: 350px !important;
    height: 40px;
  }
  ::v-deep .el-dialog__footer span > button {
    margin-top: 12px;
  }
}
.protect_the {
  ::v-deep .el-dialog {
    width: 626px !important;
    height: 362px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    line-height: 18px !important;
  }
  .mian {
    padding: 0px 24px;
    p:nth-child(1) {
      height: 84px;
      line-height: 84px;
      font-size: 15px;
      color: #333333;
    }
    p:nth-child(3) {
      font-size: 15px;
      margin-top: 20px;
      color: #999999;
    }
    ::v-deep .el-form-item__content {
      margin: 0px !important;
    }
    ::v-deep .el-input__inner {
      width: 380px;
      height: 50px;
    }
  }
  ::v-deep .el-input__suffix {
    right: 214px !important;
  }
  ::v-deep .el-input .el-input__clear {
    font-size: 18px;
  }
}
</style>